import axios from 'axios';
import { User } from 'types/user';
import httpClient from 'http/httpClient';
import { LoginResponseData } from 'types/auth';

export interface AdminAccount {
  id: number;
  account_name: string;
}

export interface VerifyCodeResponse extends LoginResponseData {
  accounts?: AdminAccount[];
}

export const sendCode = async (phone: string) => {
  try {
    const { data } = await httpClient.post('/auth/send-code', { phone });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        throw Error('No account found for this phone number.');
      }
    }
    throw Error('Error sending verification code. Please try again.');
  }
};

export const verifyCode = async (phone: string, code: string) => {
  try {
    const { data } = await httpClient.post<VerifyCodeResponse>(
      '/auth/verify-code',
      { phone, code }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        throw Error('Invalid or expired code. Please try again.');
      }
    }
    throw Error('Error verifying code. Please try again.');
  }
};

export const switchAccount = async (accountId: number) => {
  try {
    const { data } = await httpClient.post<LoginResponseData>(
      '/auth/switch-account',
      { account_id: accountId }
    );
    return data;
  } catch (error) {
    throw Error('Error switching account. Please try again.');
  }
};

export const getAdminAccounts = async () => {
  const { data } = await httpClient.get<{
    accounts: AdminAccount[];
    current_account_id: number;
  }>('/auth/accounts');
  return data;
};

export const getCurrentUser = async () => {
  const { data } = await httpClient.get<User>('/me');
  return data;
};
